/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { registerLanguage } from '../_.contribution.js';
registerLanguage({
    id: 'elixir',
    extensions: ['.ex', '.exs'],
    aliases: ['Elixir', 'elixir', 'ex'],
    loader: function () { return import('./elixir.js'); }
});
